import services from '@/services/index'

type StepByStepState = {
  [key: string]: {
    step: number,
    steps: number
  }
}

type StepByStepPayload = {
  name: string,
  endpointName: string,
  data: any,
  steps?: number,
  reset?: boolean
}

type StepByStepResponse = {
  success: boolean,
  data?: any,
  errors?: Array<string>
}

const stepByStepState: StepByStepState = {}

export default async function stepByStepValidate (payload: StepByStepPayload): Promise<StepByStepResponse> {
  if (!payload.name) throw new Error('Method name required')
  if (!payload.endpointName) throw new Error('Endpoint name required')
  if (!payload.data) throw new Error('Data required')
  if (payload.steps) {
    stepByStepState[payload.name] = {
      step: 1,
      steps: payload.steps
    }
  }
  // @ts-ignore
  const serviceMethod = services.mainService ?? services.authorization?.user
  const response: any = await serviceMethod[payload.endpointName](payload.data)
  if (response.success) {
    if (payload.reset) {
      if (stepByStepState[payload.name]) stepByStepState[payload.name].step = 1
    } else {
      if (stepByStepState[payload.name]?.step === stepByStepState[payload.name].steps) {
        stepByStepState[payload.name].step = 1
      } else stepByStepState[payload.name].step += 1
    }
    return {
      success: true,
      data: response.data
    }
  } else {
    return {
      success: false,
      errors: response.data?.errors ?? ['Не удалось выполнить операцию, попробуйте снова']
    }
  }
}
